import { Contract } from "./Contract";

export class StagingContracts {
    periodContracts: Contract[] = [];
    otherContracts: Contract[] = [];
    periodTotals: Contract = new Contract();
    otherTotals: Contract = new Contract();
}